const translations = require("./translations");

module.exports = function (language, code, replacements = []) {
  let translation = translations[code][language];

  if (replacements.length > 0) {
    replacements.forEach((replacement, index) => {
      translation = translation.replace(`__$${index + 1}__`, replacement);
    });
  }

  return translation;
};
